
(function () {
  const done = new WeakSet();

  function initOne(wrapper){
    if (!wrapper || done.has(wrapper)) return;

    const slider = wrapper.querySelector('.product-image-slider');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('.product-image-slide'));
    if (!slides.length) return;

    // 1) active state (JS will still control the cycle)
    slides.forEach(s => s.classList.remove('is-active'));
    let i = 0;
    slides[0].classList.add('is-active');

    // 2) arrows
    const arrowsHost = wrapper.querySelector('.custom-arrows');
    if (slides.length > 1 && arrowsHost && !arrowsHost.children.length) {
      arrowsHost.innerHTML =
        '<button class="custom-arrow prev" aria-label="Previous">‹</button>' +
        '<button class="custom-arrow next" aria-label="Next">›</button>';

      const prevBtn = arrowsHost.querySelector('.prev');
      const nextBtn = arrowsHost.querySelector('.next');

      function go(n){
        slides[i].classList.remove('is-active');
        i = (i + n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
      }
      prevBtn.addEventListener('click', (e)=>{ e.preventDefault(); e.stopPropagation(); go(-1); });
      nextBtn.addEventListener('click', (e)=>{ e.preventDefault(); e.stopPropagation(); go(1); });
    }

    // 3) hover auto-cycle
    let timer = null;
    const card = wrapper.closest('.grid-product') || wrapper;

    function start(){
      if (slides.length < 2 || timer) return;
      timer = setInterval(()=> {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, 1200);
    }
    function stop(){
      if (timer){ clearInterval(timer); timer = null; }
      slides[i].classList.remove('is-active');
      i = 0;
      slides[0].classList.add('is-active');
    }
    card.addEventListener('mouseenter', start);
    card.addEventListener('mouseleave', stop);

    // 4) Make the image area navigate to the product link
const mask =
  wrapper.closest('.grid__item-image-wrapper')?.querySelector('.grid-product__image-mask') || wrapper;

const link =
  wrapper.closest('.grid-product__content')?.querySelector('a.grid-product__link');

function isMobile() {
  return window.matchMedia('(max-width: 768px)').matches;
}

function shouldIgnore(ev) {
  return ev.target.closest('.custom-arrow') || ev.target.closest('.bag-icon') || ev.target.closest('button,a,input,select,textarea,label');
}

function goToProduct(ev) {
  if (!link || !mask) return;
  if (shouldIgnore(ev)) return;

  // stop other handlers that may be consuming the first tap
  ev.preventDefault();
  ev.stopPropagation();
  ev.stopImmediatePropagation?.();

  window.location.href = link.href;
}

if (mask && link) {
  mask.style.cursor = 'pointer';

  // desktop
  mask.addEventListener('click', (ev) => {
    if (isMobile()) return; // mobile handled via touchend
    goToProduct(ev);
  });

  // mobile: use touchend so it navigates in a single tap
  mask.addEventListener('touchend', (ev) => {
    if (!isMobile()) return;
    goToProduct(ev);
  }, { passive: false });
}

    done.add(wrapper);
  }

  function scan(ctx){
    (ctx || document).querySelectorAll('.product-image-slider-wrapper').forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', ()=> scan(document));

  // Re-init after filters / AJAX (collections) AND product recommendations on PDP
  [
    'collection:updated','collection:reloaded','facets:updated','facet:updated','ajaxProductFilter:rendered',
    'shopify:section:load',
    'product-recommendations:loaded','product-recommendations:updated'  // ⬅️ important for "You may also like"
  ].forEach(evt => document.addEventListener(evt, e => scan(e.target || document)));

  // Fallback observer if HTML is swapped without events
  const grids = document.querySelectorAll('[data-product-grid], .product-grid, .grid--uniform, product-recommendations');
  grids.forEach((grid) => {
    new MutationObserver(() => scan(grid)).observe(grid, { childList:true, subtree:true });
  });
})();



// mark DOM ready (unchanged)
document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.classList.add('mw-dom-ready');
});


// Quick ADD to cart -----------------------------------
function handleQuickAddClick(e, handle) {
  e.preventDefault();  
  e.stopPropagation(); 
  showQuickAddModal(handle); 
}

// part -2

(() => {
  // Polyfill for CSS.escape (older browsers)
  if (typeof CSS === 'undefined' || typeof CSS.escape !== 'function') {
    window.CSS = window.CSS || {};
    CSS.escape = function (value) { return String(value).replace(/[^a-zA-Z0-9_\-]/g, '\\$&'); };
  }

  const onReady = (fn) => document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", fn)
    : fn();

  onReady(() => {
    // Elements
    const quickAddModal   = document.getElementById("quickAddModal");
    const colorOptionsDiv = document.getElementById("color-options");
    const sizeOptionsDiv  = document.getElementById("size-options");
    const addToBagBtn     = document.getElementById("add-to-bag-btn");
    const viewProductBtn  = document.getElementById("view-product-btn");
    const colorCountSpan  = document.getElementById("color-count");
    const scrollable      = document.querySelector(".quick-add-scrollable");
    const previewImg      = document.getElementById("variant-preview-img");
    const qtyInput        = document.querySelector(".js-modal-qty__num");
    const plusBtn         = document.querySelector(".js-modal-qty__adjust--plus");
    const minusBtn        = document.querySelector(".js-modal-qty__adjust--minus");

    if (!quickAddModal) return;

    let currentProductData = null;
    const selectedOptions = {};
    let activeVariant = null;

    // Bind quantity controls (idempotent)
    function bindQtyControls() {
      if (qtyInput) qtyInput.value = 1; // reset every (re)bind
      if (plusBtn && qtyInput && !plusBtn.dataset.bound) {
        plusBtn.dataset.bound = "1";
        plusBtn.addEventListener("click", () => {
          qtyInput.value = (parseInt(qtyInput.value || "1", 10) + 1).toString();
        });
      }
      if (minusBtn && qtyInput && !minusBtn.dataset.bound) {
        minusBtn.dataset.bound = "1";
        minusBtn.addEventListener("click", () => {
          const n = Math.max(1, parseInt(qtyInput.value || "1", 10) - 1);
          qtyInput.value = n.toString();
        });
      }
    }
    bindQtyControls(); // initial

    // Close modal
    window.closeQuickAddModal = function () {
      quickAddModal.classList.add("hidden");
      quickAddModal.classList.remove("is-open");

      colorOptionsDiv.innerHTML = "";
      sizeOptionsDiv.innerHTML = "";
      document.querySelectorAll(".quick-add-options.extra-option").forEach(el => el.remove());
      if (colorCountSpan) colorCountSpan.innerText = "0";

      addToBagBtn.disabled = true;
      addToBagBtn.onclick = null; // clear previous variant handler

        // ✅ Reset button state & text/icon
  if (addToBagBtn) {
    addToBagBtn.classList.remove("active", "added");

    const desktopText = addToBagBtn.querySelector(".btn-text.desktop-only");
    const mobileIcon = addToBagBtn.querySelector(".btn-icon.mobile-only");

    if (desktopText) {
  desktopText.textContent = "Add to Bag";
  desktopText.classList.remove("slide-in", "slide-out");
}
if (mobileIcon) {
  mobileIcon.src = "https://ministerwhite.com/cdn/shop/t/28/assets/add-to-cart-white.png?v=102375225090545128931756382573";
  mobileIcon.classList.remove("slide-in", "slide-out");
}

  }

      Object.keys(selectedOptions).forEach(k => delete selectedOptions[k]);
      activeVariant = null;

      if (previewImg) { previewImg.src = ""; previewImg.style.display = "none"; }
      if (qtyInput) qtyInput.value = 1; // ensure reset on close too
       document.body.classList.remove("no-scroll"); 
    };

    // Open modal
    window.showQuickAddModal = function (handle) {
      if (!handle) return;

      fetch(`/products/${handle}.js`)
        .then(res => { if (!res.ok) throw new Error("Fetch failed"); return res.json(); })
        .then(data => {
          currentProductData = data;

          // Show modal
          quickAddModal.classList.remove("hidden");
          quickAddModal.classList.add("is-open");
          quickAddModal.setAttribute("aria-hidden", "false");

          // Reset UI/State
          Object.keys(selectedOptions).forEach(k => delete selectedOptions[k]);
          addToBagBtn.disabled = true;
          addToBagBtn.onclick = null;
          if (viewProductBtn) viewProductBtn.href = `/products/${handle}`;
          if (qtyInput) qtyInput.value = 1; // reset to 1 on open

          if (previewImg) {
            previewImg.src = (data.images && data.images[0]) || "";
            previewImg.style.display = previewImg.src ? "inline-block" : "none";
          }

          renderOptions(data);
          autoSelectSingleValueOptions();
          bindQtyControls(); // re-ensure qty listeners exist and value=1
        })
        .catch(() => {});
        document.body.classList.add("no-scroll");
    };

    // Delegated trigger (works even without inline onclick)
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(".bag-icon");
      if (!trigger) return;
      const handle = trigger.dataset.handle;
      if (handle) window.showQuickAddModal(handle);
    });

    // ESC to close
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") window.closeQuickAddModal();
    });

    // Render options
    function renderOptions(product) {
      const options = product.options;
      const variants = product.variants;
      const availableVariants = variants.filter(v => v.available);

      const optionMap = {};
      const availableMap = {};

      options.forEach((opt, idx) => {
        optionMap[opt.name]   = [...new Set(variants.map(v => String(v.options[idx]).trim()))];
        availableMap[opt.name]= new Set(availableVariants.map(v => String(v.options[idx]).trim()));
      });

      const keys = Object.keys(optionMap);
      const colorKey = keys.find(k => /color|border|shade/i.test(k));
      const sizeKey  = keys.find(k => /size/i.test(k) && !/color/i.test(k));
      const otherKeys= keys.filter(k => k !== colorKey && k !== sizeKey);

      document.querySelectorAll(".quick-add-options.extra-option").forEach(el => el.remove());

      if (colorKey) {
        if (colorCountSpan) colorCountSpan.innerText = optionMap[colorKey].length;
        colorOptionsDiv.innerHTML = optionMap[colorKey].map(val => {
          const label = String(val).trim();
          const isAvail = availableMap[colorKey].has(label);
          return `<button class="swatch-btn ${!isAvail ? 'disabled' : ''}" data-type="${colorKey}" data-value="${label}" ${!isAvail ? 'disabled title="Not available"' : ''}>${label}</button>`;
        }).join("");
      } else {
        colorOptionsDiv.innerHTML = "";
        if (colorCountSpan) colorCountSpan.innerText = "0";
      }

      if (sizeKey) {
        sizeOptionsDiv.innerHTML = optionMap[sizeKey].map(val => {
          const label = String(val).trim();
          const isAvail = availableMap[sizeKey].has(label);
          return `<button class="swatch-btn ${!isAvail ? 'disabled' : ''}" data-type="${sizeKey}" data-value="${label}" ${!isAvail ? 'disabled title="Not available"' : ''}>${label}</button>`;
        }).join("");
      } else {
        sizeOptionsDiv.innerHTML = "";
      }

      otherKeys.forEach(key => {
        const container = document.createElement("div");
        container.className = "quick-add-options extra-option";
        const buttons = optionMap[key].map(val => {
          const label = String(val).trim();
          const isAvail = availableMap[key].has(label);
          return `<button class="swatch-btn ${!isAvail ? 'disabled' : ''}" data-type="${key}" data-value="${label}" ${!isAvail ? 'disabled title="Not available"' : ''}>${label}</button>`;
        }).join("");
        container.innerHTML = `<h3 class="quick-add-title">${key}</h3>${buttons}`;
        scrollable.appendChild(container);
      });

      attachOptionListeners();
      updateOptionAvailability();
    }

    function onSwatchClick(e) {
      const btn   = e.currentTarget;
      const type  = btn.dataset.type;
      const value = btn.dataset.value;
      document.querySelectorAll(`.swatch-btn[data-type="${CSS.escape(type)}"]`).forEach(b => b.classList.remove("selected"));
      btn.classList.add("selected");
      selectedOptions[type] = value;
      validateSelections();
      updateOptionAvailability();
    }

    function attachOptionListeners() {
      document.querySelectorAll(".swatch-btn").forEach(btn => {
        if (btn.dataset.bound === "1" || btn.classList.contains("disabled")) return;
        btn.dataset.bound = "1";
        btn.addEventListener("click", onSwatchClick);
      });
    }

    function updateOptionAvailability() {
      if (!currentProductData) return;
      const names = currentProductData.options.map(o => o.name);
      const variants = currentProductData.variants;

      names.forEach((name) => {
        const btns = document.querySelectorAll(`.swatch-btn[data-type="${CSS.escape(name)}"]`);
        btns.forEach(btn => {
          const testValue = btn.dataset.value;
          const testSel = { ...selectedOptions, [name]: testValue };

          const isAvail = variants.some(variant =>
            variant.available &&
            variant.options.every((ov, i) => {
              const chosen = testSel[names[i]];
              return !chosen || String(ov) === String(chosen);
            })
          );

          if (!isAvail) { btn.classList.add("disabled"); btn.setAttribute("disabled", "true"); }
          else { btn.classList.remove("disabled"); btn.removeAttribute("disabled"); }
        });
      });
    }

    // Auto-select any option group with only ONE enabled value
function autoSelectSingleValueOptions() {
  if (!currentProductData) return;

  const optionNames = currentProductData.options.map(o => o.name);

  optionNames.forEach(name => {
    const btns = document.querySelectorAll(
      `.swatch-btn[data-type="${CSS.escape(name)}"]`
    );

    // Only enabled ones count
    const enabledBtns = [...btns].filter(b => !b.classList.contains("disabled"));

    if (enabledBtns.length === 1) {
      const btn = enabledBtns[0];
      btn.classList.add("selected");
      selectedOptions[name] = btn.dataset.value;
    }
  });

  validateSelections();
  updateOptionAvailability();
}
// end default select

    function validateSelections() {
      if (!currentProductData) return;
      const names = currentProductData.options.map(o => o.name);
      const allChosen = names.every(n => !!selectedOptions[n]);

      if (!allChosen) { addToBagBtn.disabled = true; activeVariant = null; addToBagBtn.onclick = null; return; }

      const match = currentProductData.variants.find(v =>
        v.options.every((ov, i) => String(ov) === String(selectedOptions[names[i]]))
      );

      activeVariant = match || null;

if (match && match.available) {
  addToBagBtn.disabled = false;
  addToBagBtn.classList.add("active"); 
  addToBagBtn.onclick = () => addToCart(match.id);
} else {
  addToBagBtn.disabled = true;
  addToBagBtn.classList.remove("active");
  addToBagBtn.onclick = null;
}
    }

    // Add to cart (latest Impulse compatible; drawer refresh handled by theme)
function addToCart(variantId) {
  if (!variantId) return;

  const qtyInput = document.querySelector(".js-modal-qty__num");
  const quantity = Math.max(1, parseInt(qtyInput?.value || "1", 10));

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    },
    credentials: "same-origin",
    body: JSON.stringify({ id: variantId, quantity })
  })
  .then(async (res) => {
    const text = await res.text();
    if (!res.ok) throw new Error(text || "Add to cart failed");
    return JSON.parse(text);
  })
  .then(() => {
    // Close quick-add (safe if not present)
    // Animate button to show "Added"
addToBagBtn.classList.add("animating");

const desktopText = addToBagBtn.querySelector(".btn-text.desktop-only");
const mobileIcon = addToBagBtn.querySelector(".btn-icon.mobile-only");

// Add slide-out class first
if (desktopText) desktopText.classList.add("slide-out");
if (mobileIcon) mobileIcon.classList.add("slide-out");

// Wait for slide-out animation (300ms), then swap content
setTimeout(() => {
  if (desktopText) {
    desktopText.textContent = "Added";
    desktopText.classList.remove("slide-out");
    desktopText.classList.add("slide-in");
  }

  if (mobileIcon) {
    mobileIcon.src = "https://cdn.shopify.com/s/files/1/0470/0389/3911/files/added-icon.png?v=1756891792";
    mobileIcon.classList.remove("slide-out");
    mobileIcon.classList.add("slide-in");
  }
}, 300);

// Wait 1 second to show "Added" before closing modal
setTimeout(() => {
  if (typeof window.closeQuickAddModal === "function") closeQuickAddModal();
}, 1300);


    // Nudge Impulse/Theme (non-blocking)
    try { document.dispatchEvent(new CustomEvent("cart:build")); } catch(_) {}
    try { document.dispatchEvent(new CustomEvent("cart:updated")); } catch(_) {}

    // Shiprocket Smart Cart refresh (if app present)
    try {
      if (typeof window.cooeeUpdateCartDrawer === "function") {
        window.cooeeUpdateCartDrawer();
      } else if (typeof window.updateMiniCartSection === "function") {
        window.updateMiniCartSection();
      }
    } catch(_) {}

    // Pull fresh cart, then toggle the header bubble
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then(r => r.json())
      .then(cart => {
        // Broadcast for any other listeners
        try { document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart })); } catch(_) {}

        // 🔔 Update your dot bubble(s)
        const bubbles = document.querySelectorAll(".cart-link__bubble");
        bubbles.forEach(bub => {
          if (cart.item_count > 0) {
            bub.classList.add("cart-link__bubble--visible");
          } else {
            bub.classList.remove("cart-link__bubble--visible");
          }
        });
      });
  })
  .catch((err) => {
    console.error("Add to cart error:", err);
    alert("Error adding to cart. Please try again.");
  });
}

  });
})();

// Sticky add to cart ------------------------------------
document.addEventListener("DOMContentLoaded", () => {
  const isPDP =
    document.body.classList.contains("template-product") ||
    /\/products\//.test(window.location.pathname);
  if (!isPDP) return;

  const stickyBar = document.getElementById("stickyAddToCartBar");
  if (!stickyBar) return;

  const btn = document.getElementById("stickyAddToCartBtn");
  if (!btn) return;

  const priceEl = document.getElementById("priceValue");
  const qtyInput = stickyBar.querySelector(".js-qty__num");
  const minusBtn = stickyBar.querySelector(".js-qty__adjust--minus");
  const plusBtn = stickyBar.querySelector(".js-qty__adjust--plus");
  const variants = Array.isArray(window.productVariants) ? window.productVariants : [];

  // --- message BELOW quantity ---
  const stockMsg = (() => {
    let el = stickyBar.querySelector("#stickyStockMsg");
    if (!el) {
      el = document.createElement("div");
      el.id = "stickyStockMsg";
      el.style.cssText = "margin-top:6px;font-size:12px;line-height:1.2;color:#c00;display:none;";
      (stickyBar.querySelector(".quantity-wrapper") || stickyBar).insertAdjacentElement("afterend", el);
    }
    return el;
  })();

  const setMsg = (t) => {
    stockMsg.textContent = t || "";
    stockMsg.style.display = t ? "block" : "none";
  };

  const norm = (s) =>
    String(s || "").trim().toLowerCase().replace(/\s+/g, " ").replace(/s$/, ""); // Sleeve/Sleeves

  const getQty = () => {
    const v = parseInt(qtyInput?.value || "1", 10);
    return Number.isFinite(v) ? Math.max(1, v) : 1;
  };
  const setQty = (n) => {
    if (!qtyInput) return;
    const v = parseInt(n, 10);
    qtyInput.value = String(Number.isFinite(v) ? Math.max(1, v) : 1);
  };

  const getOptionValue = (optionIndex) => {
    const checked = document.querySelector(`[data-index="${optionIndex}"] input:checked`);
    if (!checked) return null;
    const raw = (checked.value || "").trim();
    if (!raw || raw === "true" || raw === "false") {
      const txt = checked.closest("label")?.querySelector(".swatch-option-name")?.textContent?.trim();
      return txt || raw || null;
    }
    return raw;
  };

  // Stock from: "Low stock - 7 items left"
  let maxStock = null; // number|null
  const readStock = () => {
    const el = document.querySelector("[data-product-inventory]");
    if (!el) return null;
    const txt = (el.textContent || "").toLowerCase();
    const m = txt.match(/(\d+)\s*items?\s*left/);
    if (m) return parseInt(m[1], 10);
    if (txt.includes("out of stock") || txt.includes("sold out")) return 0;
    return null;
  };

  // Variant (works for 0/1/2/3 options)
  let currentVariantId = null;
  const resolveVariant = () => {
    if (!variants.length) return null;

    const has1 = !!document.querySelector('[data-index="option1"]');
    const has2 = !!document.querySelector('[data-index="option2"]');
    const has3 = !!document.querySelector('[data-index="option3"]');

    if (!has1 && !has2 && !has3) return variants[0];

    const sel = [];
    if (has1) sel[0] = getOptionValue("option1");
    if (has2) sel[1] = getOptionValue("option2");
    if (has3) sel[2] = getOptionValue("option3");

    const found = variants.find((v) => {
      if (!Array.isArray(v.options)) return false;
      for (let i = 0; i < sel.length; i++) {
        const want = sel[i];
        if (want == null) return false;
        const got = v.options[i];
        if (i === 1) {
          if (norm(got) !== norm(want) && String(got) !== String(want)) return false;
        } else {
          if (String(got) !== String(want)) return false;
        }
      }
      return true;
    });

    return found || variants[0];
  };

  // Button "Added" until cart drawer closes
  const DEFAULT_BTN_TEXT = btn.textContent?.trim() || "Add to Bag";
  const isDrawerOpen = () => {
    const drawer = document.getElementById("CartDrawer");
    if (drawer?.classList.contains("is-open")) return true;
    if (document.body.classList.contains("drawer-is-open")) return true;
    if (document.documentElement.classList.contains("js-drawer-open")) return true;
    return false;
  };
  const setBtnState = (state) => {
    if (state === "busy") {
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
      return;
    }
    btn.removeAttribute("aria-busy");

    if (state === "added") {
      btn.textContent = "Added";
      btn.disabled = true;
      return;
    }

    // ready
    btn.textContent = DEFAULT_BTN_TEXT;
    btn.disabled = !(currentVariantId && (typeof maxStock !== "number" || maxStock > 0));
  };

  const watchDrawerCloseToResetBtn = () => {
    const drawer = document.getElementById("CartDrawer");
    const targets = [drawer, document.body, document.documentElement].filter(Boolean);
    const obs = new MutationObserver(() => {
      if (!isDrawerOpen()) setBtnState("ready");
    });
    targets.forEach((t) => obs.observe(t, { attributes: true, attributeFilter: ["class"] }));
  };

  const applyStockRules = (fromUserAction) => {
    const q = getQty();

    if (typeof maxStock !== "number") {
      setMsg("");
      plusBtn && (plusBtn.disabled = false);
      minusBtn && (minusBtn.disabled = q <= 1);
      return;
    }

    if (maxStock <= 0) {
      setQty(1);
      setMsg("No stock available");
      plusBtn && (plusBtn.disabled = true);
      minusBtn && (minusBtn.disabled = false);
      btn.disabled = true;
      return;
    }

    if (q > maxStock) setQty(maxStock);

    const qq = getQty();
    plusBtn && (plusBtn.disabled = qq >= maxStock);
    minusBtn && (minusBtn.disabled = qq <= 1);

    // show message ONLY when qty hits/exceeds stock
    if (fromUserAction && qq >= maxStock) setMsg(`Only ${maxStock} left`);
    else setMsg("");
  };

  const updateUIFromVariant = () => {
    const v = resolveVariant();
    if (!v) return;

    currentVariantId = v.id;
    btn.setAttribute("data-variant-id", String(currentVariantId));
    if (priceEl) priceEl.textContent = ((v.price || 0) / 100).toFixed(2);

    maxStock = readStock();
    applyStockRules(false);
    setBtnState("ready");
  };

  const ensureDefaultsSelected = () => {
    ["option1", "option2", "option3"].forEach((idx) => {
      const group = document.querySelector(`[data-index="${idx}"]`);
      if (!group) return;
      if (group.querySelector("input:checked")) return;
      const first = group.querySelector("input");
      if (first) {
        first.checked = true;
        first.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  };

  // Events: qty
  minusBtn?.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      setQty(getQty() - 1);
      applyStockRules(true);
    },
    true
  );

  plusBtn?.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      setQty(getQty() + 1);
      applyStockRules(true);
    },
    true
  );

  qtyInput?.addEventListener("input", () => applyStockRules(true));

  // Events: swatches (0/1/2/3 option products supported)
  document
    .querySelectorAll('[data-index="option1"] input,[data-index="option2"] input,[data-index="option3"] input')
    .forEach((el) => el.addEventListener("change", updateUIFromVariant));

  // Shiprocket + minicart
  const getCart = async () =>
    fetch("/cart.js", { credentials: "same-origin", cache: "no-store" }).then((r) => r.json());

  const syncShiprocket = async (variantIdNum) => {
    const cart = await getCart();
    const item = (cart.items || []).find((it) => Number(it.variant_id) === Number(variantIdNum));
    if (!item) return;
    if (typeof window.handleItemQuantityUpdate === "function") {
      try {
        window.handleItemQuantityUpdate(item.key, item.quantity, "add");
      } catch (_) {}
    }
  };

  const openMiniCart = () => {
    try {
      document.dispatchEvent(new CustomEvent("cart:open"));
      document.dispatchEvent(new CustomEvent("cart:updated"));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (_) {}

    const triggers = [
      ".cart-link",
      ".cart-link__bubble",
      "[data-cart-drawer-open]",
      "[href='/cart']",
      "a[href*='cart']",
      ".site-header__cart",
      ".header-cart",
    ];

    for (const sel of triggers) {
      const el = document.querySelector(sel);
      if (el) {
        el.click();
        break;
      }
    }
  };

  const addToCart = async (variantIdNum, qty) => {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "same-origin",
      body: JSON.stringify({ id: Number(variantIdNum), quantity: Number(qty) }),
    });

    let data = null;
    try {
      data = await res.json();
    } catch (_) {}

    return { status: res.status, data };
  };

  // Sticky ATC (lock + "Added" until drawer closes)
  let isStickyAdding = false;
  document.addEventListener(
    "click",
    async (e) => {
      const clicked = e.target?.closest?.("#stickyAddToCartBtn");
      if (!clicked) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (isStickyAdding) return;
      isStickyAdding = true;

      setBtnState("busy");

      try {
        updateUIFromVariant();

        const vId = clicked.getAttribute("data-variant-id") || currentVariantId;
        if (!vId) return;

        maxStock = readStock();
        if (typeof maxStock === "number" && maxStock <= 0) {
          setMsg("No stock available");
          setBtnState("ready");
          return;
        }

        let qty = getQty();
        if (typeof maxStock === "number") qty = Math.min(qty, maxStock);

        const { status, data } = await addToCart(vId, qty);

        if (status === 422) {
          setMsg(data?.message || data?.description || "Not enough stock");
          setBtnState("ready");
          return;
        }

        setMsg("");
        await syncShiprocket(vId);

        setQty(1);
        applyStockRules(false);

        setBtnState("added");
        openMiniCart();
      } catch (_) {
        setBtnState("ready");
      } finally {
        isStickyAdding = false;
      }
    },
    true
  );

  // Sticky show/hide
  window.addEventListener("scroll", () => {
    const triggerEl =
      window.innerWidth <= 768
        ? document.querySelector(".product-block--header")
        : document.querySelector(".social-sharing");
    if (!triggerEl) return;

    const triggerBottom = triggerEl.getBoundingClientRect().bottom;
    if (triggerBottom < 0) stickyBar.classList.remove("hidden");
    else stickyBar.classList.add("hidden");
  });

  // Keep stock in sync when theme updates text
  const invEl = document.querySelector("[data-product-inventory]");
  if (invEl) {
    const obs = new MutationObserver(() => {
      maxStock = readStock();
      applyStockRules(false);
      setBtnState(isDrawerOpen() ? "added" : "ready");
    });
    obs.observe(invEl, { childList: true, subtree: true, characterData: true });
  }

  // Init
  ensureDefaultsSelected();
  updateUIFromVariant();
  setQty(1);
  watchDrawerCloseToResetBtn();
});



// =--------------------------------------------------

// footer custom APP
document.addEventListener("DOMContentLoaded", function () {
  const appBlock = document.querySelector(".footer__item--custom_BaHnpT");
  if (appBlock) {
    appBlock.innerHTML = `
   <div class="app-download-section">
  <h3>Download Our App For The Best Shopping Experience.</h3>
  <div class="app-badges">
    <a href="https://play.google.com/store/apps/details?id=com.ministerwhite&hl=en_IN" target="_blank" rel="noopener">
      <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
    </a>
    <a href="https://apps.apple.com/in/app/minister-white/id1643480817" target="_blank" rel="noopener">
      <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" />
    </a>
  </div>
</div>

    `;
  }
});

// For Tab Section

document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.minister-tab-link');
  const contents = document.querySelectorAll('.minister-tab-content');
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      this.classList.add('active');
      document.getElementById(this.dataset.tab).classList.add('active');
    });
  });
});

// Product Image - Zoomin option ---------------------------------

(function () {
  const ZOOM = 2.5;
  const LENS_W = 140;
  const LENS_H = 140;

  function getActiveSlide() {
    return document.querySelector('.product-main-slide.is-selected');
  }

  function getActiveImg() {
    const slide = getActiveSlide();
    if (!slide) return null;
    return slide.querySelector('img');
  }

function ensurePanel() {
  let panel = document.getElementById('fk-zoom-panel');
  if (panel) return panel;

  panel = document.createElement('div');
  panel.id = 'fk-zoom-panel';
  panel.className = 'fk-zoom-panel';
  panel.setAttribute('aria-hidden', 'true');

  document.body.appendChild(panel); // ✅ important
  return panel;
}


  function getLargeSrc(img) {
    const src = img.currentSrc || img.src || "";
    return src.replace(/width=\d+/i, 'width=2000');
  }

  function positionPanel(panel, img) {
  const info = document.querySelector('.product__info, .product__content, .product-single__meta');
  if (!info) return;

  const infoRect = info.getBoundingClientRect();
  const imgRect = img.getBoundingClientRect();
const MAX_PANEL_HEIGHT = 420;
  const headerOffset = 110;
  const gap = 0;

  panel.style.position = 'fixed';
  panel.style.left = (infoRect.left + gap) + 'px';
  panel.style.top = Math.max(headerOffset, infoRect.top) + 'px';
  panel.style.width = infoRect.width + 'px';
  
  panel.style.height = Math.min(imgRect.height, MAX_PANEL_HEIGHT) + 'px'; // ✅ match image height
  panel.style.zIndex = '9999';
}


  function setupZoom() {
    if (window.matchMedia('(max-width: 1024px)').matches) return;

    const img = getActiveImg();
    if (!img) return;

    const slide = getActiveSlide();
    const wrap = slide.querySelector('.product-image-main .image-wrap') || slide.querySelector('.product-image-main');
    if (!wrap) return;

    const panel = ensurePanel();

    // Remove old lens (only inside active slide)
    const oldLens = wrap.querySelector('.fk-zoom-lens');
    if (oldLens) oldLens.remove();

    // Make sure hover events work even if theme blocks pointer events
    img.style.pointerEvents = 'auto';

    const lens = document.createElement('div');
    lens.className = 'fk-zoom-lens';
    lens.style.width = LENS_W + 'px';
    lens.style.height = LENS_H + 'px';

    wrap.style.position = 'relative';
    wrap.appendChild(lens);

function show() {
  lens.style.display = 'block';
  panel.style.display = 'block';
  panel.setAttribute('aria-hidden', 'false');

  // ✅ position correctly even before scroll
  positionPanel(panel, img);

  const bigSrc = getLargeSrc(img);
  panel.style.backgroundImage = `url("${bigSrc}")`;

  const rect = img.getBoundingClientRect();
  panel.style.backgroundSize = (rect.width * ZOOM) + 'px ' + (rect.height * ZOOM) + 'px';
}


    function hide() {
      lens.style.display = 'none';
      panel.style.display = 'none';
      panel.setAttribute('aria-hidden', 'true');
    }

    function move(e) {
      const rect = img.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      let lx = x - LENS_W / 2;
      let ly = y - LENS_H / 2;

      const maxX = rect.width - LENS_W;
      const maxY = rect.height - LENS_H;

      lx = Math.max(0, Math.min(lx, maxX));
      ly = Math.max(0, Math.min(ly, maxY));

      lens.style.left = lx + 'px';
      lens.style.top = ly + 'px';

      const bgX = -(lx * ZOOM);
      const bgY = -(ly * ZOOM);

      panel.style.backgroundPosition = `${bgX}px ${bgY}px`;
    }

    // IMPORTANT: attach events to wrapper (more reliable than img in themes)
    wrap.addEventListener('mouseenter', show);
    wrap.addEventListener('mouseleave', hide);
    wrap.addEventListener('mousemove', move);
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupZoom();

    // Flickity slide change support
    document.addEventListener('settle.flickity', function () {
      setupZoom();
    });

    const slider = document.querySelector('.flickity-slider');
    if (slider) {
      const obs = new MutationObserver(() => setupZoom());
      obs.observe(slider, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
  });
})();


// click on the zoom button

document.addEventListener("DOMContentLoaded", function () {

  function isMobile() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  function restoreScroll() {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.classList.remove('photoswipe--open', 'modal-open');
  }

  let lastTap = 0;

  document.addEventListener("touchend", function (e) {
    if (!isMobile()) return;

    const tappedImage = e.target.closest(".product-image-main, .product-image-main img, [data-product-image-main]");
    if (!tappedImage) return;

    const now = Date.now();
    const delta = now - lastTap;

    if (delta > 0 && delta < 300) {
      const activeSlide = tappedImage.closest(".product-main-slide.is-selected")
        || document.querySelector(".product-main-slide.is-selected");

      if (!activeSlide) return;

      const zoomBtn = activeSlide.querySelector(".js-photoswipe__zoom");
      if (!zoomBtn) return;

      zoomBtn.click();
      setTimeout(restoreScroll, 300);

      e.preventDefault(); // stop second tap click
    }

    lastTap = now;
  }, { passive: false });

});


// New Arrival Text in Sort

document.addEventListener("DOMContentLoaded", function () {

  function modifySortDropdown() {
    const selects = document.querySelectorAll('select[name="SortBy"]');

    selects.forEach(select => {

      let newArrivalOption = null;

      [...select.options].forEach(option => {

        // Rename
        if (option.text.trim().toLowerCase() === "date, new to old") {
          option.text = "New Arrival";
          newArrivalOption = option;
        }

      });

      // Move to top
      if (newArrivalOption) {
        select.prepend(newArrivalOption);
      }

    });
  }

  modifySortDropdown();

  // Shopify reloads collection sections via AJAX
  document.addEventListener("shopify:section:load", modifySortDropdown);

});

// share option on single product

(function () {
  var btn = document.getElementById('productShareBtn');
  var dropdown = document.getElementById('productShareDropdown');
  if (!btn || !dropdown) return;

  var pageUrl = encodeURIComponent(window.location.href);
  var pageTitle = encodeURIComponent(document.title);

  // Toggle dropdown
  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    dropdown.classList.toggle('is-open');
  });

  // Close on outside click
  document.addEventListener('click', function () {
    dropdown.classList.remove('is-open');
  });
  dropdown.addEventListener('click', function (e) { e.stopPropagation(); });

  // Facebook
  document.getElementById('sharefacebook').href =
    'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
  document.getElementById('sharefacebook').target = '_blank';

  // WhatsApp
  document.getElementById('sharewhatsapp').href =
    'https://wa.me/?text=' + pageTitle + '%20' + pageUrl;
  document.getElementById('sharewhatsapp').target = '_blank';

  // LinkedIn
  document.getElementById('sharelinkedin').href =
    'https://www.linkedin.com/shareArticle?mini=true&url=' + pageUrl + '&title=' + pageTitle;
  document.getElementById('sharelinkedin').target = '_blank';

  // Copy Link
  document.getElementById('sharecopylink').addEventListener('click', function () {
    navigator.clipboard.writeText(window.location.href).then(function () {
      var msg = document.getElementById('shareCopiedMsg');
      msg.classList.add('visible');
      setTimeout(function () {
        msg.classList.remove('visible');
        dropdown.classList.remove('is-open');
      }, 1800);
    });
  });
})();